export class PCTableInputModel {
  public constructor(
    data: any,
    rowButtoms: PCTableRowButtonModel[],
    sortable: boolean,
    startIndex: number,
    sortingColumnName?: string,
    direction?: string
  ) {
    this.rowButtoms = rowButtoms;
    this.data = data;
    this.startIndex = startIndex;

    this.sorable = sortable;

    if (sortingColumnName) {
      this.sortingColumnName = sortingColumnName;
    } else {
      this.sortingColumnName = ``;
    }

    if (direction) {
      this.direction = direction;
    } else {
      this.direction = ``;
    }
  }

  public data: any;
  public rowButtoms: PCTableRowButtonModel[] = [];
  public sortingColumnName: string;
  public direction: string;
  public sorable: boolean;
  public startIndex: number;
}

export class PCTableRowButtonModel {
  constructor(name, className, icon) {
    this.name = name;
    this.className = className;
    this.icon = icon;
  }

  public name: string;
  public className: string;
  public icon: string;
  public condition?: string;
  public secondCondition?: string;
  public redirectUrl?: string;
}

export class PCTableOutputModel {
  constructor(action, data) {
    this.action = action;
    this.data = data;
  }

  public action: string;
  public data: any;
}
